export enum ShiftStatus {
  OPEN = "OPEN",
  PRE_OPEN = "PRE_OPEN"
}

export const SHIFT_STATUS_OPTIONS = [
  { value: ShiftStatus.OPEN, label: "Aberto" },
  { value: ShiftStatus.PRE_OPEN, label: "Pré-abertura" }
];

export function normalizeShiftStatus(value: string | null | undefined): ShiftStatus {
  if (!value) {
    return ShiftStatus.PRE_OPEN;
  }

  const normalized = value.trim().toUpperCase();
  if (normalized === ShiftStatus.OPEN) {
    return ShiftStatus.OPEN;
  }

  if (normalized === ShiftStatus.PRE_OPEN || normalized === "PRE-OPEN" || normalized === "PRE OPEN") {
    return ShiftStatus.PRE_OPEN;
  }

  return ShiftStatus.PRE_OPEN;
}

export function getShiftStatusLabel(value: string | null | undefined): string {
  const normalizedStatus = normalizeShiftStatus(value);
  const option = SHIFT_STATUS_OPTIONS.find((status) => status.value === normalizedStatus);
  return option?.label ?? normalizedStatus;
}